export namespace TextUtils {
  export function normalize(value: string) {
    const text = `${value || ''}`;
    return text
      .replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec))
      .replace(/(&.+;)/ig, (match, dec) => String.fromCharCode(match.charCodeAt(0)));
  }
}
